import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { VisionVO } from '@wizeoo/akm-compute-lib';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { Model } from 'src/app/model/model';

@Component({
    selector: 'vision-thumb-renderer',
    template: ` <wiz-hgroup #hgContainer height="100%" width="100%" verticalAlign="center" gap=3 style="justify-content: center;">
                   <wiz-image width="24px" height="24px" [sourceObservable]="iconOrDie" style="align-self: center;"></wiz-image>
                </wiz-hgroup>`,
    styles: [':host {max-width: 100%}'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

/**
 * Renderer des actions sur une application dans le grid
 */
export class VisionThumbRenderer implements AgRendererComponent {

    constructor(private cdref: ChangeDetectorRef, public elementRef: ElementRef) { }

    public item: VisionVO;

    public get iconOrDie(): Observable<string> {
        return Model.getInstance().visionEngine.getVisionIconOrDie(this.item);
    }

    refresh(params: ICellRendererParams): boolean {
        this.item = params.data;
        this.cdref.markForCheck();
        return true;
    }

    agInit(params: ICellRendererParams) {
        this.item = params.data;
        this.cdref.markForCheck();
    }

}
